import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { t } from "@/lib/i18n";
import { Boxes, AlertTriangle } from "lucide-react";

export function InventoryPanel() {
  const { lang } = useLang();
  const [items, setItems] = useState([]);
  const [lowCount, setLowCount] = useState(0);
  const [threshold, setThreshold] = useState(5);

  useEffect(() => {
    api.get(`/automation/inventory?threshold=${threshold}`).then((r) => {
      setItems(r.data.items || []);
      setLowCount(r.data.low_stock_count || 0);
    });
  }, [threshold]);

  return (
    <div className="hq-card overflow-hidden" data-testid="inventory-panel">
      <div className="p-5 border-b border-white/10 flex items-center gap-2 flex-wrap">
        <Boxes size={14} className="text-[color:var(--hq-cyan)]" />
        <div className="font-display text-lg">{t(lang, "inv_title")}</div>
        <span className="font-mono text-xs text-white/40">{items.length}</span>
        {lowCount > 0 && (
          <span className="font-mono text-[10px] uppercase text-[color:var(--hq-warning)] border border-[color:var(--hq-warning)]/40 px-2 py-0.5">
            <AlertTriangle size={10} className="inline mr-1" />
            {lowCount} {t(lang, "inv_low_stock")}
          </span>
        )}
        <label className="ml-auto flex items-center gap-2 text-xs font-mono uppercase text-white/50">
          {t(lang, "inv_threshold")}
          <input
            data-testid="inv-threshold-input"
            type="number"
            min={0}
            max={99}
            value={threshold}
            onChange={(e) => setThreshold(Math.max(0, Number(e.target.value) || 0))}
            className="hq-input w-20 text-center"
          />
        </label>
      </div>

      <table className="hq-table">
        <thead>
          <tr>
            <th></th>
            <th>{t(lang, "inv_col_product")}</th>
            <th>{t(lang, "inv_col_stock")}</th>
            <th>{t(lang, "inv_col_variants")}</th>
          </tr>
        </thead>
        <tbody>
          {items.map((r) => (
            <tr key={r.shopify_id} data-testid={`inv-row-${r.shopify_id}`}>
              <td>
                {r.low_stock ? (
                  <AlertTriangle size={12} className="text-[color:var(--hq-warning)]" />
                ) : (
                  <span className="hq-dot hq-dot-green" />
                )}
              </td>
              <td>
                <div className="text-sm">{r.title}</div>
                <div className="text-white/40 font-mono text-[10px]">/{r.handle}</div>
              </td>
              <td className={`font-mono text-xs ${r.low_stock ? "text-[color:var(--hq-warning)]" : ""}`}>
                {r.total_inventory}
              </td>
              <td className="font-mono text-xs text-white/60">{r.variants}</td>
            </tr>
          ))}
          {items.length === 0 && (
            <tr>
              <td colSpan={4} className="text-center py-8 font-mono text-xs text-white/40">
                {t(lang, "inv_empty")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
